import Vue from "vue";
import { INotificationOnClickResult, Notification } from "./notification";
import { TaskService } from "@/services";

export class TaskNewMessageNotification extends Notification {
	public async onClick(vue: Vue):Promise<INotificationOnClickResult> {
		let task = await TaskService.getTask(this.Data.TaskID);
		return {
			routeTo: `/tasks/${task.FolderID}/${task.ID}/`
		};
	}

	public getIcon():string {
		return "comment";
	}

	public getActionKey():string {
		return "open-task";
	}
}
